import React from 'react';
import './Establish.css'
import WA from '../WeAre/WA'


const Establish = () => {

return (
    <div className="establish-container">
<WA/>

    </div>
)


}




export default Establish;